import { render, staticRenderFns } from "./restBill.vue?vue&type=template&id=dfe588ac&scoped=true&"
import script from "./restBill.vue?vue&type=script&lang=js&"
export * from "./restBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe588ac",
  null
  
)

export default component.exports